import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { adminApi } from "../../lib/portalApi";
import { toast } from "sonner";
import { Save, Settings as Cog } from "lucide-react";

const FIELDS = [
  ["google_analytics_id", "Google Analytics ID", "G-XXXXXXXXXX"],
  ["google_tag_manager_id", "Google Tag Manager ID", "GTM-XXXXXXX"],
  ["google_search_console_code", "Search Console Verification", "<meta name=\"google-site-verification\"...>"],
  ["meta_pixel_id", "Meta Pixel ID", "1234567890"],
  ["platform_banner", "Platform Banner Text", "Banner shown at top of public site (optional)"],
];

export default function SettingsTab() {
  const [form, setForm] = useState({});

  const load = async () => {
    const r = await adminApi.settingsGet();
    setForm(r || {});
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await adminApi.settingsPut(form);
      toast.success("Settings saved");
    } catch (err) { toast.error(err?.response?.data?.detail || "Save failed"); }
  };

  return (
    <form onSubmit={save} className="glass p-6 space-y-4" data-testid="admin-settings-tab">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-electric">
        <Cog size={12} /> Platform Settings
      </div>
      {FIELDS.map(([k, label, placeholder]) => (
        <div key={k}>
          <label className="text-[10px] uppercase tracking-[0.22em] text-steel">{label}</label>
          <Input value={form[k] || ""} onChange={e => setForm({ ...form, [k]: e.target.value })}
            placeholder={placeholder}
            className="bg-navy-deep border-gold-dim/40 mt-1 font-mono text-sm"
            data-testid={`settings-${k}`} />
        </div>
      ))}
      <div className="flex justify-end pt-2">
        <Button type="submit" className="btn-gold h-10 px-5 text-xs" data-testid="settings-save-btn">
          <Save size={14} className="mr-2" /> Save Settings
        </Button>
      </div>
      <p className="text-[11px] text-cream-dim pt-2 border-t border-gold-dim/15">
        These values are read by the public site header (analytics injection and optional banner).
        They are exposed via <code className="text-gold">/api/public/settings</code>.
      </p>
    </form>
  );
}
